import {ActionTypes} from "modules/redux_types";
import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};

const types = [
  "WORKFLOWS_FETCH",
  "WORKFLOWS_CLEAR",
  "WORKFLOW_FETCH",
  "WORKFLOW_UPDATE",
  "WORKFLOW_DUPLICATE",
  "WORKFLOW_REMOVE",
  "WORKFLOW_ADD",
  "WORKFLOW_CLEAR",
  "WORKFLOW_INPUT_ADD",
  "WORKFLOW_INPUT_UPDATE",
  "WORKFLOW_INPUT_REMOVE",
  "WORKFLOW_INPUT_REORDER",
  "WORKFLOW_TASK_ADD",
  "WORKFLOW_TASK_UPDATE",
  "WORKFLOW_TASK_REMOVE",
  "WORKFLOW_TASK_REORDER",
  "WORKFLOW_PREREQUISITE_ADD",
  "WORKFLOW_PREREQUISITE_FETCH",
  "WORKFLOW_PREREQUISITE_REMOVE",
  "WORKFLOW_PREREQUISITE_UPDATE_INPUT_VALUE",
  "WORKFLOW_INSTANCES_FETCH",
  "WORKFLOW_INSTANCE_ADD",
  "WORKFLOW_INSTANCE_UPDATE_NAME",
  "WORKFLOW_INSTANCE_UPDATE_DEFAULT_ASSET_NAME",
  "WORKFLOW_INSTANCE_UPDATE_IS_ARCHIVED",
  "WORKFLOW_INSTANCE_UPDATE_IS_PUBLIC",
  "LLM_RUNS_FETCH",
  "LLM_RUN_BATCHES_RECENT_FETCH",
  "LLM_RUNS_BATCH_SCORES_FETCH",
  "LLM_RUNS_COMPARE_FETCH",
  "LLM_RUNS_CLEAR",
  "LLM_RUN_FETCH",
  "LLM_RUN_CLEAR",
  "LLM_RUN_RERUN",
  "ACTION_DEFINITION_FETCH",
  "CONTEXTS_FETCH",
  "FLUSH_ASSISTANTS",
  "WORKFLOW_TEST_ADD",
  "WORKFLOW_TEST_UPDATE",
  "WORKFLOW_TEST_DELETE",
  "WORKFLOW_TEST_RESULT_FETCH",
  "WORKFLOW_TESTS_FETCH",
  "TESTSET_ADD",
  "TESTSETS_FETCH",
  "LLM_RUN_TESTS_RERUN",
  "LLM_RUN_TESTS_RERUN_MULTIPLE",
  "DATA_ASSET_RUN",
  "DATA_ASSET_CONFIG_RUNS_FETCH",
] as const;

types.forEach(type => createReduxPromiseActionType(actionTypes, type));

export type ActionType = typeof types[number];

export type WorkflowsActionTypes = ActionTypes<ActionType>;

export default actionTypes as WorkflowsActionTypes;
